/* Faites entendre votre voix — AI-02 (Bible §51 · TOV §27).
   Preset labels are natural and demonstrable; the merchant tests against a
   sample review before the first real use. Workspace tone with a Location
   override — warmth is a setting, facts never are. */
import { useState } from 'react'
import { Button, ErrorState, Field, Input, KV, Switch } from '@/ui'
import { useVoice } from './api'
import { Chargement, Retour } from './parts'

export default function Voix() {
  const { data, isPending, isError, refetch } = useVoice()
  const [ton, setTon] = useState<string | null>(null)
  const [vouvoie, setVouvoie] = useState<boolean | null>(null)

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger votre configuration."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const tonActuel = ton ?? data.tone
  const vous = vouvoie ?? data.vouvoiement

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 680 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>Faites entendre votre voix</h2>

      <div>
        <span className="f-label">Ton de la réponse</span>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {data.tones.map(t => (
            <Button key={t} size="sm" variant={t === tonActuel ? 'primary' : 'quiet'}
              onClick={() => setTon(t)}>{t}</Button>
          ))}
        </div>
      </div>

      <KV rows={[['Adresse', <span key="a" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
        vous <Switch checked={!vous} onChange={e => setVouvoie(!e.currentTarget.checked)}
          aria-label="Passer au tutoiement" /> tutoiement
      </span>]]} />

      <Field label="Votre établissement en quelques mots">
        {id => <Input id={id} defaultValue={data.description} />}
      </Field>
      <Field label="Habitudes &amp; mots à éviter">
        {id => <Input id={id} defaultValue={data.habits} />}
      </Field>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="quiet">Tester avec un avis exemple</Button>
        <Button size="sm" variant="primary">Enregistrer</Button>
      </div>
    </div>
  )
}
